import { Component, HostBinding, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractEntity } from '@entity-framework/entity-record/state/abstract-entity';
import { ActiveCintraProductService } from '@app/active-cintra-product.service';
import { SearchInputComponent } from '@design/forms/search-input/search-input.component';
import { BodyMediumComponent } from '@design/typography/body-md/body-medium.component';
import { TestIdDirective } from '@design/core/test-id.directive';
import { BureauProfile, BureauProfileExtended } from '@app/bureau/bureau-profile';
import { AuthStorageService } from '@auth-n/state/auth-storage.service';

/**
 * Material menu which presents the list of Organisations the user can select to work with.
 * Embedded in the {@link HeaderComponent}.
 */
@UntilDestroy()
@Component({
  selector: 'app-bureau-menu',
  templateUrl: './bureau-menu.component.html',
  styleUrls: ['../_context-menu.scss'],
  providers: [FormGroupDirective],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    SearchInputComponent,
    BodyMediumComponent,
    TestIdDirective
  ]
})
export class BureauMenuComponent implements OnInit {
  searchTermControl = new UntypedFormControl('');
  formGroup = new UntypedFormGroup({
    searchTerm: this.searchTermControl
  });

  filterSet$: BehaviorSubject<AbstractEntity[]> = new BehaviorSubject<AbstractEntity[]>([]);

  @ViewChild('searchInput') searchInput!: { elementRef: { nativeElement: { focus: () => void } } };

  @Input() activeBureau!: BureauProfile;
  @Input() bureauProfiles!: BureauProfileExtended[];

  constructor(private authStorageService: AuthStorageService) {}

  ngOnInit() {
    this.filterSet$.next(this.bureauProfiles || []);
  }

  focusSearch() {
    this.searchTermControl.setValue('');
    this.searchInput.elementRef.nativeElement.focus();
  }

  filter(searchTerm: string) {
    if (!searchTerm) {
      this.filterSet$.next(this.bureauProfiles.slice());
      return;
    } else {
      searchTerm = searchTerm.toLowerCase();
    }

    this.filterSet$.next(this.bureauProfiles.filter((item) => item.name.toLowerCase().indexOf(searchTerm) > -1));
  }

  changeBureau(bureauProfile: AbstractEntity) {
    this.authStorageService.setBureauProfileId(bureauProfile.id);
    ActiveCintraProductService.cachedActiveProduct = 'Bureau';
    window.location.href = '/';
  }
}
